import tool from 'common/src/modules/shared/copilot/utils/creators/tool';
import toolResult from 'common/src/modules/shared/copilot/utils/creators/toolResult';
import {z} from 'zod';
import {ToolExecuteParams} from 'common/src/modules/shared/copilot/copilot.types';
import {V2CardAgentToolName} from '../../promptToCardAgentV2.enums';
import {NodeType} from 'common/src/modules/nodes/nodes.types';
import {OptimizationCardScratchpadState} from '../../scratchpad/optimizationCardScratchpad.types';
import validateAgentScratchpad from '../../utils/general/validateAgentScratchpad';

const updateOptimizationOutputInputSchema = z.object({
  outputId: z.number().describe('The id of the output to update'),
  name: z.string().describe('The new name of the output'),
});

function errorResult(message: string) {
  return toolResult(JSON.stringify({status: 'error', message}));
}

export default function updateOptimizationOutputTool() {
  async function execute(
    params: ToolExecuteParams<
      typeof updateOptimizationOutputInputSchema,
      OptimizationCardScratchpadState
    >,
  ) {
    const {outputId, name} = params.input;
    const validatedScratchpad = validateAgentScratchpad<OptimizationCardScratchpadState>(
      params.toolUtils.agentScratchpad,
      NodeType.GENERAL_OPTIMIZATION,
    );

    const existingOutput = validatedScratchpad.card.outputs.find((output) => output.id === outputId);

    if (!existingOutput) {
      return errorResult(`Optimization output with id ${outputId} not found.`);
    }

    existingOutput.name = name;

    return toolResult(`Optimization output renamed to "${name}"`);
  }

  return tool<typeof updateOptimizationOutputInputSchema, OptimizationCardScratchpadState>({
    name: V2CardAgentToolName.UpdateOptimizationOutput,
    displayName: 'Updating optimization output',
    description: 'Update the name of an existing optimization output.',
    inputSchema: updateOptimizationOutputInputSchema,
    execute,
  });
}
